import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Card from 'react-bootstrap/Card';
import { getChartColor, largeNumberFormatter, formatQuarterYear } from '../utils/helpers'
import CustomTooltip from './CustomTooltip.js';

const StackedKeyIndicatorChart = ({ data }) => {
  const regions = data?.Data?.[0]?.Values.map(item => item.Name);

  return (
    <Card>
      <Card.Title style={{ textAlign: 'center', marginTop: 12 }}>{data?.Name}</Card.Title>
      <p style={{ textAlign: 'center', marginTop: 12, paddingLeft: 40, paddingRight: 40 }}>{data?.Description}</p>
      <Card.Body>
        <ResponsiveContainer width="100%" height={400} >
          {data?.Data.length > 0 ? (
            <BarChart data={data?.Data} stackOffset="sign" style={{ padding: 2 }}>
              <CartesianGrid vertical={false} />
              <XAxis dataKey={(e) => e.XAxis} fontSize={12} angle={-40} dy={20} dx={-20} />            <YAxis fontSize={12} tickFormatter={largeNumberFormatter} />
              <YAxis fontSize={12} tickFormatter={largeNumberFormatter} />
              <Tooltip content={<CustomTooltip showTotal={true} />} />
              <Legend verticalAlign="bottom" wrapperStyle={{ paddingTop: "40px" }} />

              {regions && regions.map((region, index) => (
                <Bar
                  key={region}
                  name={region}
                  dataKey={(entry) => {
                    const regionData = entry.Values.find((item) => item.Name === region);
                    return regionData ? regionData.Value : 0;
                  }}
                  stackId="a"
                  stroke={getChartColor(index)}
                  fill={getChartColor(index)}
                />
              ))}
            </BarChart>
          ) : (
            <div style={{ display: 'flex', height: '100%', width: '100%', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', fontWeight: 500, }}>
              No Data
            </div>
          )}
        </ResponsiveContainer>
      </Card.Body>
    </Card>
  );
};

export default StackedKeyIndicatorChart;